import { render } from "./city-table-page.vue?vue&type=template&id=cef5021e&scoped=true"
import script from "./city-table-page.vue?vue&type=script&lang=js"
export * from "./city-table-page.vue?vue&type=script&lang=js"

import "./city-table-page.vue?vue&type=style&index=0&id=cef5021e&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef5021e"]])

export default __exports__